import { atom } from 'jotai';

export const openViewLogModalAtom = atom(false);
